
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/czesci-auta-dostawcze/lokalizacja/[lokalizacja]",
      function () {
        return require("private-next-pages/czesci-auta-dostawcze/lokalizacja/[lokalizacja]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/czesci-auta-dostawcze/lokalizacja/[lokalizacja]"])
      });
    }
  